// Função central para obter a base da API em qualquer ambiente.
// Prioridades:
// 1. VITE_API_BASE_URL (definida no build)
// 2. Se rodando em browser e domínio *.onrender.com => caminho relativo '/api'
// 3. Fallback desenvolvimento local http://localhost:5000/api

export function getApiBase(): string {
  // @ts-ignore
  const envUrl = typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_BASE_URL;
  if (envUrl) return envUrl.replace(/\/$/, '');

  // Em ambiente de browser (dev), use o proxy do Vite
  if (typeof window !== 'undefined') {
    return '/api';
  }

  // Fallback para ambientes server-side locais
  return 'http://localhost:5001/api';
}

export function apiUrl(path: string): string {
  const base = getApiBase();
  if (path.startsWith('http')) return path; // já absoluto
  return `${base}${path.startsWith('/') ? path : '/' + path}`;
}

// Debug inicial (só em dev)
if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.log('[apiBase] Base API detectada =', getApiBase());
}
